import { render, staticRenderFns } from "./DocBox.vue?vue&type=template&id=769aca9d&scoped=true&"
import script from "./DocBox.vue?vue&type=script&lang=js&"
export * from "./DocBox.vue?vue&type=script&lang=js&"
import style0 from "./DocBox.vue?vue&type=style&index=0&id=769aca9d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "769aca9d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('769aca9d')) {
      api.createRecord('769aca9d', component.options)
    } else {
      api.reload('769aca9d', component.options)
    }
    module.hot.accept("./DocBox.vue?vue&type=template&id=769aca9d&scoped=true&", function () {
      api.rerender('769aca9d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2Y9MEoLy97bMv/JS/comp/DocBox.vue"
export default component.exports